import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isNil, isNull } from 'lodash'
import moment from 'moment'
import {
  Button,
  Col,
  Form,
  Icon,
  Input,
  Row,
  Upload,
  DatePicker,
  Radio,
  Typography,
  Divider,
  Modal,
  Checkbox
} from 'antd'
import { useDeepEffect } from '../../../../../utils/hooks'
import { useDispatch } from 'react-redux'
import { fetchBrandActivityCoverList } from '../../../../../modules/brandActivity'
import {
  getBase64,
  validateUploadedImage,
  uploadBrandActivityImage,
  deleteBrandActivityPhotoList
} from '../../../../../utils/services'
import { disabledBeforeCurrentDate } from '../../../../../utils/dateTime'
import { ACTION } from '../../../../../utils/constants'
const { Text } = Typography
const { TextArea } = Input

const uploadButton = (
  <div>
    <Icon type="plus" />
    <div className="ant-upload-text">เพิ่มรูปภาพ</div>
  </div>
)

const initActivityConditions = [
  {
    id: 1,
    conditionDesc: 'คำนวนคะแนนกิจกรรมจาก Product ที่รองรับ',
    enabled: true
  },
  {
    id: 2,
    conditionDesc: 'คำนวนคะแนนกิจกรรมจาก Hero ที่รองรับ',
    enabled: true
  },
  {
    id: 3,
    conditionDesc: 'คำนวนคะแนนกิจกรรมจาก Hero Confirm',
    enabled: true
  }
]

const visibleAppOptions = [
  { label: 'Green2get', value: 'user' },
  { label: 'Web Hero Recycle', value: 'hero' },
  { label: 'หน้าร้านฮีโร่', value: 'loma' }
]

const allVisibleApps = visibleAppOptions.map((option) => option.value)

const InfoFrom = (props) => {
  const dispatch = useDispatch()
  const {
    onOk,
    onCancel,
    form,
    action,
    formState,
    coverList,
    setCoverList,
    removedImages,
    setRemovedImages
  } = props

  const { getFieldDecorator, validateFields } = form
  const [imageUrl, setImageUrl] = useState('')
  const [cover, setCover] = useState('')
  const [receiveType, setReceiveType] = useState('')
  const [selectedValue, setSelectedValue] = useState(null)
  const [conditionValue1, setConditionValue1] = useState(null)
  const [conditionValue2, setConditionValue2] = useState(null)
  const [conditionValue3, setConditionValue3] = useState(null)
  const [onlyBrandHero, setOnlyBrandHero] = useState(true)
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState('')

  useDeepEffect(() => {
    if (!isNull(formState) && !isNil(formState)) {
      form.setFieldsValue({
        activityName: formState.activityName,
        activityDetail: formState.activityDetail,
        activityHeroDetail: formState.activityHeroDetail,
        scoreType: formState.scoreType,
        receiveType: formState.receiveType,
        effectiveDate: moment(formState.effectiveDate),
        expirationDate: moment(formState.expirationDate),
        url: formState.url,
        onlyBrandHero: formState.onlyBrandHero,
        visibleApps:
          formState.visibleApps && formState.visibleApps.length > 0
            ? formState.visibleApps
            : allVisibleApps
      })
      if (formState.activityConditions.length != 0) {
        form.setFieldsValue({
          activityCondition1: formState.activityConditions[0].enabled,
          activityCondition2: formState.activityConditions[1].enabled,
          activityCondition3: formState.activityConditions[2].enabled
        })
      }
      setImageUrl(formState.image)
      setCover(formState.cover)
      setReceiveType(formState.receiveType)
      setSelectedValue(formState.scoreType)
      setConditionValue1(formState.activityConditions[0].enabled)
      setConditionValue2(formState.activityConditions[1].enabled)
      setConditionValue3(formState.activityConditions[2].enabled)
      setOnlyBrandHero(formState.onlyBrandHero)
    }
    return () => {
      form.resetFields()
      setImageUrl('')
      setCover('')
      setReceiveType('')
      setSelectedValue('')
      setConditionValue1('')
      setConditionValue2('')
      setConditionValue3('')
      setCoverList([])
      setOnlyBrandHero(true)
    }
  }, [formState])

  useDeepEffect(() => {
    async function fetchCoverData() {
      if (formState && formState.id) {
        const response = await dispatch(
          fetchBrandActivityCoverList(formState.id)
        )

        if (response && response.length > 0) {
          setCoverList(
            response.map((cover) => ({
              uid: cover.id.toString(),
              name: cover.filename,
              status: 'done',
              url: cover.url
            }))
          )
        }
      }
    }

    fetchCoverData()
  }, [formState])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        let img = null
        let cover = null
        const data = {
          activityName: values.activityName,
          activityDetail: values.activityDetail,
          activityHeroDetail : values.activityHeroDetail,
          effectiveDate: values.effectiveDate.toISOString(),
          expirationDate: values.expirationDate.toISOString(),
          scoreType: selectedValue,
          receiveType: values.receiveType,
          onlyBrandHero: onlyBrandHero,
          visibleApps:
            values.visibleApps.length === allVisibleApps.length
              ? []
              : values.visibleApps,
          activityConditions: [
            {
              ...initActivityConditions[0],
              enabled: conditionValue1
            },
            {
              ...initActivityConditions[1],
              enabled: conditionValue2
            },
            {
              ...initActivityConditions[2],
              enabled: conditionValue3
            }
          ]
        }

        if (values.cover) {
          cover = await uploadBrandActivityImage(values.cover.file)
          data.cover = cover.url
        } else {
          data.cover = formState.cover
        }

        if (action === ACTION.UPDATE) {
          data.id = formState.id
        }

        await onOk(data, coverList, removedImages)
        await form.resetFields()
        await setImageUrl('')
        await setReceiveType('')
        await setSelectedValue('')
        await setConditionValue1('')
        await setConditionValue2('')
        await setConditionValue3('')
        await setOnlyBrandHero(true)
      }
    })
  }

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file.originFileObj)
        reader.onload = () => resolve(reader.result)
      })
    }
    setPreviewImage(file.url || file.preview)
    setPreviewVisible(true)
  }

  const handleChangeCover = async (info) => {
    await getBase64(info.file, (cover) => {
      setCover(cover)
    })
  }

  const onChange = (e) => {
    setReceiveType(e.target.value)
    if (e.target.value == 'Material') {
      setSelectedValue(null)
      setConditionValue1(true)
      setConditionValue2(true)
      setConditionValue3(true)
      setOnlyBrandHero(true)
    } else {
      setSelectedValue('Piece')
      setConditionValue1(true)
      setConditionValue2(true)
      setConditionValue3(true)
      setOnlyBrandHero(true)
    }
  }

  const onChangeSelect = (e) => {
    setSelectedValue(e.target.value)
  }

  const onChangeCondition1 = (e) => {
    setConditionValue1(e.target.value)
  }
  const onChangeCondition2 = (e) => {
    setConditionValue2(e.target.value)
    if(e.target.value == false){
      setOnlyBrandHero(true)
    }
  }
  const onChangeCondition3 = (e) => {
    setConditionValue3(e.target.value)
  }

  const onChangeOnlyBrandHero = (e) => {
    setOnlyBrandHero(e.target.value)
  }

  const handleRemoveImage = async (file) => {
    try {
      const response = await deleteBrandActivityPhotoList(
        file.uid,
        formState.id
      )

      if (response) {
        const newFileList = coverList.filter((item) => item.uid !== file.uid)
        setCoverList(newFileList)
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Form name="formBrandActivity" onSubmit={onSubmit} layout="vertical">
      <Text strong>Brand Activity Info</Text>
      <div>
        <br></br>
      </div>
      <Form.Item label="ชื่อกิจกรรม">
        {getFieldDecorator(`activityName`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Row type="flex" gutter={[8, 8]}>
        <Col span={10}>
          <Form.Item label="วันเริ่มกิจกรรม">
            {getFieldDecorator(`effectiveDate`, {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก'
                }
              ]
            })(
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                disabledDate={disabledBeforeCurrentDate}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item label="วันสิ้นสุดกิจกรรม">
            {getFieldDecorator(`expirationDate`, {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก'
                }
              ]
            })(
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                disabledDate={disabledBeforeCurrentDate}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="รายละเอียดกิจกรรม">
        {getFieldDecorator(`activityDetail`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<TextArea autoSize={{ minRows: 4, maxRows: 10 }} allowClear />)}
      </Form.Item>
      <Form.Item label="รายละเอียดกิจกรรมสำหรับฮีโร่">
        {getFieldDecorator(`activityHeroDetail`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<TextArea autoSize={{ minRows: 12, maxRows: 20 }} allowClear />)}
      </Form.Item>
      <Form.Item label="ตั้งค่าการรับวัสดุ">
        {getFieldDecorator(`receiveType`, {
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(
          <Radio.Group onChange={(e) => onChange(e)}>
            <Radio value={'Material'}>รับ Material</Radio>
            <Radio value={'Barcode'}>รับ Barcode Product</Radio>
          </Radio.Group>
        )}
      </Form.Item>
      <Form.Item label="แสดงคะแนนการเข้าร่วมกิจกรรมตามลำดับ">
        {getFieldDecorator(`scoreType`)(
          <div>
            {receiveType == 'Material' ? (
              <Radio.Group
                onChange={(e) => onChangeSelect(e)}
                value={selectedValue}>
                <Radio value={'CO2'}>CO2</Radio>
                <Radio value={'Weight'}>Weight</Radio>
                <Radio value={'Frequency'}>Frequency</Radio>
                <Radio value={'Piece'} disabled>
                  Piece
                </Radio>
              </Radio.Group>
            ) : receiveType == 'Barcode' ? (
              <Radio.Group
                onChange={(e) => onChangeSelect(e)}
                value={selectedValue}>
                <Radio value={'CO2'} disabled>
                  CO2
                </Radio>
                <Radio value={'Weight'} disabled>
                  Weight
                </Radio>
                <Radio value={'Frequency'} disabled>
                  Frequency
                </Radio>
                <Radio value={'Piece'}>Piece</Radio>
              </Radio.Group>
            ) : (
              <Radio.Group
                onChange={(e) => onChangeSelect(e)}
                value={selectedValue}>
                <Radio value={'CO2'}>CO2</Radio>
                <Radio value={'Weight'}>Weight</Radio>
                <Radio value={'Frequency'}>Frequency</Radio>
                <Radio value={'Piece'}>Piece</Radio>
              </Radio.Group>
            )}
          </div>
        )}
      </Form.Item>
      <Form.Item label="รูปภาพหน้าปก">
        {getFieldDecorator(`cover`, {
          valuePropName: 'file',
          rules: [
            {
              required: isNull(formState),
              message: 'เพิ่มรูปภาพ'
            }
          ]
        })(
          <Upload
            name="avatar"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={validateUploadedImage}
            onChange={handleChangeCover}>
            {cover ? (
              <img src={cover} alt="cover" style={{ width: '100%' }} />
            ) : (
              uploadButton
            )}
          </Upload>
        )}
      </Form.Item>
      <Form.Item label="รูปภาพกิจกรรม">
        {getFieldDecorator(`image`, {
          rules: [{ required: isNull(formState), message: 'เพิ่มรูปภาพ' }]
        })(
          <Upload
            listType="picture-card"
            fileList={coverList.map((file) => ({
              ...file,
              url: file.url || file.preview
            }))}
            onPreview={handlePreview}
            onChange={({ fileList }) => setCoverList(fileList)}
            onRemove={(file) => {
              setRemovedImages([...removedImages, file])
              setCoverList(coverList.filter((item) => item.uid !== file.uid))
            }}
            beforeUpload={() => false}
            showUploadList={{ showRemoveIcon: true, showPreviewIcon: true }}>
            {coverList.length < 5 && uploadButton}
          </Upload>
        )}
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={() => setPreviewVisible(false)}>
          <img alt="preview" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Form.Item>
      <Form.Item label="ตั้งค่าการแสดงบนแอปพลิเคชัน">
        {getFieldDecorator(`visibleApps`, {
          initialValue: allVisibleApps
        })(<Checkbox.Group options={visibleAppOptions} />)}
      </Form.Item>

      <Divider />
      <Text strong>Brand Activity Condition</Text>
      <div>
        <br></br>
      </div>
      <Form.Item label="คำนวนคะแนนกิจกรรมจาก Product ที่รองรับ">
        {getFieldDecorator(`activityCondition1`)(
          <div>
            {receiveType == 'Material' ? (
              <Radio.Group
                onChange={(e) => onChangeCondition1(e)}
                value={conditionValue1}>
                <Radio value={true}>ใช่</Radio>
                <Radio value={false}>ไม่ใช่ (คำนวนจากทุก Product)</Radio>
              </Radio.Group>
            ) : (
              <Radio.Group disabled value={conditionValue1}>
                <Radio value={true}>ใช่</Radio>
                <Radio value={false}>ไม่ใช่ (คำนวนจากทุก Product)</Radio>
              </Radio.Group>
            )}
          </div>
        )}
      </Form.Item>
      <Form.Item label="คำนวนคะแนนกิจกรรมจาก Hero ที่รองรับ">
        {getFieldDecorator(`activityCondition2`)(
          <div>
            {receiveType == 'Material' ? (
              <Radio.Group
                onChange={(e) => onChangeCondition2(e)}
                value={conditionValue2}>
                <Radio value={true}>ใช่</Radio>
                <Radio value={false}>ไม่ใช่ (คำนวนจากทุกฮีโร่)</Radio>
              </Radio.Group>
            ) : (
              <Radio.Group disabled value={conditionValue2}>
                <Radio value={true}>ใช่</Radio>
                <Radio value={false}>ไม่ใช่ (คำนวนจากทุกฮีโร่)</Radio>
              </Radio.Group>
            )}
          </div>
        )}
      </Form.Item>
      <Form.Item label="คำนวนคะแนนกิจกรรมจาก Hero Confirm">
        {getFieldDecorator(`activityCondition3`)(
          <div>
            <Radio.Group
              onChange={(e) => onChangeCondition3(e)}
              value={conditionValue3}>
              <Radio value={true}>ใช่</Radio>
              <Radio value={false}>ไม่ใช่ (คำนวนเมื่อ User ส่งต่อ)</Radio>
            </Radio.Group>
          </div>
        )}
      </Form.Item>
      <Form.Item label="เข้าร่วมเฉพาะ brand hero เท่านั้น">
        {getFieldDecorator(`onlyBrandHero`)(
          <div>
            <Radio.Group
              disabled={conditionValue2 === false || receiveType == 'Barcode'}
              onChange={(e) => onChangeOnlyBrandHero(e)}
              value={onlyBrandHero}>
              <Radio value={true}>ใช่</Radio>
              <Radio value={false}>ไม่ใช่</Radio>
            </Radio.Group>
          </div>
        )}
      </Form.Item>
      <Row type="flex" justify="end" gutter={8}>
        <Col>
          <Button onClick={() => onCancel()} key="cancel" type="danger">
            ยกเลิก
          </Button>
        </Col>
        <Col>
          <Button
            name="formBrandActivity"
            key="submit"
            type="primary"
            htmlType="submit">
            บันทึก
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

InfoFrom.propTypes = {
  action: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.any.isRequired,
  onRemoveImage: PropTypes.func,
  coverList: PropTypes.array.isRequired,
  setCoverList: PropTypes.func.isRequired,
  removedImages: PropTypes.array.isRequired,
  setRemovedImages: PropTypes.func.isRequired
}

const WrappedInfoFrom = Form.create({
  name: 'InfoFrom'
})(InfoFrom)
export default WrappedInfoFrom
